<template>
  <div>
    <div class="mc-delivery-tabs">
      <b-button
        v-for="(tab, idx) in tabs"
        variant="light"
        :key="idx"
        :class="{ active: tab.hash == activeTab }"
        :disabled="tab.isDisabled"
        class="position-relative"
        @click="handleClickTab(tab.hash)"
      >
        {{ tab.title }}
        <McBadge
          v-if="tab.isNewSubmodule"
          variant="danger"
          size="small"
          type="notif"
        ></McBadge>
      </b-button>
    </div>
    <hr />
    <slot />
  </div>
</template>

<script>
import McBadge from '@/components/McBadge'
export default {
  provide() {
    return {
      activeTab: () => this.activeTab,
    }
  },
  props: {
    tabIndex: {
      type: Number,
    },
  },
  emits: ['update:tabIndex'],
  components: {
    McBadge,
  },
  data() {
    return { tabs: [], activeTab: '' }
  },
  created() {
    this.tabs = this.$children
  },
  mounted() {
    this.activeTab = this.tabs[this.tabIndex].hash
  },
  methods: {
    handleClickTab(hash) {
      this.activeTab = hash
      this.$emit(
        'update:tabIndex',
        this.tabs.findIndex((tab) => tab.hash === this.activeTab)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-delivery-tabs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin-bottom: 12px;

  & > button {
    height: 36px;
    flex-shrink: 0;
    color: $mep-color-text;
    font-weight: 500;
    transition: none;
    background: none;
    outline: none;
    border: none;
    border-radius: 4px;
    padding: 8px 20px;

    &:hover {
      background-color: $mep-secondary-100;
      color: $mep-color-text-400;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }

    &:disabled {
      color: #67718b;
    }
  }

  & > button.active {
    border: 1px solid $mep-primary;
    background-color: $mep-secondary-100;
    color: $mep-primary;
    font-weight: 600;
  }
}
</style>
